<template>
    <div class="list-page">
        <template v-if="type==='express'">
            <div v-for="(item,index) in routeConfig.children" :key="index">
                <h3>{{item.name}}</h3>
                <menu-lst :router="item"></menu-lst>
            </div>
        </template>
        <template v-if="type==='service'">
            <menu-lst :router="routeConfig"></menu-lst>
        </template>
    </div>
</template>

<script>
import { mapMutations } from "vuex"
import Menu from '@/components/header/droplist/'
import ExpressRoute from '@/components/header/menuConfig/express'
import ServiceRoute from '@/components/header/menuConfig/service'
    export default {
        name: 'productList',
        data () {
            return {
                type: '',
                routeConfig : []
            }
        },
        methods : {
            ...mapMutations({
                setTitle: "setTitle",
                setShowCustomer: "setShowCustomer",
            }),
        },
        components: {
            'menu-lst': Menu,
        },
        created() {
            this.setShowCustomer(true)
            const type = this.$route.query.type
            if (type) {
                this.type = type
                const routeConfig= {
                    'express': ExpressRoute,
                    'service': ServiceRoute
                }[type] || {}
                const title = routeConfig.name
                title && this.setTitle(title+'查询')
                routeConfig && (this.routeConfig = routeConfig)
            }
        },
        components: {
            'menu-lst': Menu
        },
    }
</script>

<style lang="scss" scoped>
.list-page {
    width: 100%;
    background: #efefef;
    h3 {
        color: #333;
        font-size: .3rem;
        font-weight: 600;
        padding: .2rem .3rem;
    }
    ul {
        padding: 0 .3rem;
        box-shadow: 0 2px .1rem 2px rgba(200,200,200, .3);
        margin: 0 auto;
    }
    .menu-wrapper {
        background: #fff;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/product/list/index.vue